import { ShippingAddress } from '@features/contacts/types/shippingAddress'
import { formatAddress } from '@features/contacts/utils/formatAddress'

export const getDeliveryAddress = (shippingAddress?: ShippingAddress | null): string | null => {
  if (!shippingAddress) {
    return null
  }

  return (
    formatAddress([
      shippingAddress.addressLine1,
      shippingAddress.addressLine2,
      [shippingAddress.zipcode, shippingAddress.city].filter(Boolean).join(' ') || null,
    ]) || null
  )
}
